import { render, staticRenderFns } from "./PrizeFooter.vue?vue&type=template&id=6d0a5ea0&scoped=true&"
import script from "./PrizeFooter.vue?vue&type=script&lang=ts&"
export * from "./PrizeFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PrizeFooter.vue?vue&type=style&index=0&id=6d0a5ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a5ea0",
  null
  
)

export default component.exports